import React from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import {
    getLiveGuidelineProductTagsByLiveGuidelineProductIdAction,
    createLiveGuidelineProductTagAction,
} from '../../redux/actions/liveGuidelineProductTagActions';
import TagAssignmentModal from '../common/tagAssignmentModal/TagAssignmentModal';

interface Props {
    visible: boolean;
    liveGuidelineProductId?: number | null;
    onClose: () => void;
    onSaved?: () => void;
}

const LiveGuidelineProductTagsModal: React.FC<Props> = ({
    visible,
    liveGuidelineProductId,
    onClose,
    onSaved,
}) => {
    const dispatch = useAppDispatch();
    const existingTags = useAppSelector((s) =>
        liveGuidelineProductId
            ? (s as any).liveGuidelineProductTagReducer.byLiveGuidelineProductId[
                  liveGuidelineProductId
              ]?.tags ?? []
            : [],
    );
    const existingTagIds = existingTags.map((t: any) => t.tagId);

    return (
        <TagAssignmentModal
            visible={visible}
            existingTagIds={existingTagIds}
            onClose={onClose}
            onSaved={onSaved}
            onAssign={(tagId) =>
                dispatch(
                    createLiveGuidelineProductTagAction({
                        liveGuidelineProductId: liveGuidelineProductId!,
                        tagId,
                    }),
                ) as Promise<unknown>
            }
            onRefresh={() =>
                liveGuidelineProductId &&
                dispatch(
                    getLiveGuidelineProductTagsByLiveGuidelineProductIdAction(
                        liveGuidelineProductId,
                    ),
                )
            }
            inputId="add-live-guideline-product-tag-input"
        />
    );
};

export default LiveGuidelineProductTagsModal;
